import React, { useEffect } from 'react'
import OilMenuView from '../../containers/Oil/OilMenu/OilMenu'
import { useDispatch, useSelector } from 'react-redux';
import { getLitersReceived } from '../../actions/oilActions';

const OilMenu = () => {

  const dispatch = useDispatch();
  const { totalLiters } = useSelector(state => state.oil);
  const { userInfo } = useSelector((state) => state.userInfo);

  useEffect(() => {
    if (userInfo.franchiseID) {
      if (userInfo.franchiseID.state === 2) {
        dispatch(getLitersReceived(userInfo.franchiseID._id));
        return () => { }
      }
    }
    else if(userInfo.warehouseID){
      dispatch(getLitersReceived(userInfo.warehouseID));
    }
  }, [userInfo]);

  return (
    <OilMenuView litersReceived={totalLiters} />
  )
}

export default OilMenu